import { useCallback } from "react";

const useUserLogoutEvent = () => {
  const handleUserLogoutEvent = useCallback(() => {
    if (window.webengage) {
      // Log the user logout event with WebEngage
      window.webengage.user.logout();
      console.log("User logout event sent to WebEngage");
    } else {
      console.error("WebEngage is not defined");
    }
  }, []);

  return { handleUserLogoutEvent };
};

export default useUserLogoutEvent;
